import { useSelector } from "react-redux";
import { useBizDevelopmentDashboard } from "../../../../../pages/BizDevelopment/Dashboard/hooks/useBizDevelopmentDashboard";
import FloatingActionItems from "../../../../../pages/FloatingItems/FloatingActionItems";
import OverviewTabs from "./OverviewTabs";
import {
  selectBizOverviewAccountSummaryOutput,
  selectBizOverviewConversionsOutput,
} from "../../../../../features/bizDevelopmentDashboardSlice";

const Overview = () => {
  const { getSitesFromParams } = useBizDevelopmentDashboard();
  const accountSummaryData = useSelector(selectBizOverviewAccountSummaryOutput);
  const conversionsData = useSelector(selectBizOverviewConversionsOutput);
  return (
    <>
      <OverviewTabs />
      <div data-tracker="842">
        <FloatingActionItems
          selectedSiteFloatingAction={getSitesFromParams().join(",")}
          selectedDimensionsFloatingAction=""
          trackIdFloatingAction="843"
          disabledButton={
            accountSummaryData.length === 0 && conversionsData.length === 0
          }
        />
      </div>
    </>
  );
};

export default Overview;
